import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  faBooks,
  faCog,
  faFlag,
  faHome,
  faTable,
  faTools,
  faUsersRectangle,
} from '@fortawesome/pro-solid-svg-icons';
import { DemandScienceDefault } from '@frontend/theme';
import { NavItemService } from '@frontend/util/nav-item-access';
import { AuthService } from 'auth';
import { PrimeNG } from 'primeng/config';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'ds-adex-wrapper',
  template: '<router-outlet></router-outlet>',
  imports: [RouterModule],
  host: {
    '[style.height]': '"100%"',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdexWrapperComponent {
  constructor() {
    inject(PrimeNG).setConfig({
      theme: {
        preset: DemandScienceDefault,
        options: {
          prefix: '',
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    });
    const authService = inject(AuthService);
    const navItemService = inject(NavItemService);

    navItemService.setAppName('Ad Experiences');
    navItemService.setUser(
      combineLatest([
        authService.actualUserOktaData$,
        authService.myTerminusMarketer$,
      ]).pipe(
        map(([oktaData, marketer]) => {
          return {
            fullname: oktaData?.name || '<unknonwn>',
            email: oktaData?.email || '<unknown>',
            couName: marketer?.name || '<unknown>',
          };
        }),
      ),
    );

    navItemService.setNavItems([
      [
        {
          text: 'Home',
          tooltip: 'Home',
          path: 'adex/home',
          icon: faHome,
        },
        {
          text: 'Campaign Overview',
          tooltip: 'Campaign Overview',
          path: 'adex/new-campaign-overview',
          icon: faFlag,
          requireNotLimitedView: true,
        },
        {
          text: 'Matched Accounts',
          tooltip: 'Matched Accounts',
          path: 'adex/matched-accounts',
          icon: faUsersRectangle,
          requireNotLimitedView: true,
        },
      ],
      [
        {
          title: 'Reports',
          tooltip: 'Reports',
          icon: faTable,
          items: [
            {
              text: 'Site Visits',
              path: 'adex/site-visits',
              requireConfiguration: 'enabled',
              requireLimitedView: true,
              id: 'adex-site-visits',
            },
            {
              text: 'Engagement Funnel',
              path: 'adex/analyze/engagement-funnel',
              requireLimitedView: true,
              id: 'account-funnel-measure-studio-adex',
            },
            {
              text: 'Aggregate Campaigns',
              path: 'adex/aggregate-campaigns',
            },
            {
              text: 'Aggregate Creatives',
              path: 'adex/aggregate-creatives',
            },
            {
              text: 'Aggregate Accounts',
              tooltip: 'Aggregate Accounts',
              path: 'adex/aggregate-account-report',
              // gainsightId: 'aggregateaccounts_beta',
            },
          ],
        },
      ],
      [
        {
          text: 'Creative Library',
          tooltip: 'Creative Library',
          path: 'adex/creative-library',
          icon: faBooks,
          requireNotLimitedView: false,
        },
        /** Not in use currently */
        // {
        //   title: 'Terminus Labs',
        //   tooltip: 'Terminus Labs',
        //   icon: faFlaskGear,
        //   items: [],
        // },
      ],
      [
        {
          title: 'Settings',
          tooltip: 'Settings',
          requireNotLimitedView: true,
          icon: faCog,
          items: [
            {
              text: 'Settings',
              path: 'adex/settings',
            },
            {
              text: 'Integrations',
              path: 'adex/integrations',
            },
            {
              text: 'Conversions',
              path: 'adex/conversions/configuration',
            },
          ],
        },
      ],
      [
        {
          title: 'Admin Tools',
          tooltip: 'Admin Tools',
          icon: faTools,
          requireMyTAdmin: true,
          id: 'adex-admin',
          items: [
            // {
            //   text: 'Admin Dash',
            //   path: 'adex/admin',
            // },
            {
              text: 'Admin Settings',
              path: 'adex/admin/settings',
            },
            {
              text: 'Demo Mode',
              path: 'adex/demo-config',
            },
            {
              text: 'Switch User',
              path: 'adex/admin/switch-user',
            },
            {
              text: 'Trade Desk',
              path: 'https://desk.thetradedesk.com/app/partner/8xag3ri/home/dashboard',
            },
            {
              text: 'Forecasting',
              path: 'adex/forecasting-report',
            },
            {
              text: 'Admin Entitlement Toggle',
              path: '',
            },
          ],
        },
      ],
    ]);
  }
}
